import type { PluginWebManifest } from '@reflex/plugin-api/web';
import { ABSOLUTE_PATH_SCANNER_PATTERN } from './shared/detect-paths.js';

export const sandboxFilesystemWeb: PluginWebManifest = {
  // Standalone, org-scoped file-preview page. The preview pane's "Open in new
  // tab" affordance links here (`/orgs/<slug>/sandbox-filesystem/<agentId>?path=…`)
  // instead of at the raw `/download` API URL: a top-level browser navigation
  // can't attach the web client's `Authorization: Bearer` header, so the raw
  // endpoint 401s in a fresh tab. Opening an in-app page boots the SPA, which
  // authenticates over XHR (bearer + org from the URL slug) like every other
  // filesystem call. Default flags → mounted under `/orgs/:orgSlug/`.
  routes: [
    {
      path: '/sandbox-filesystem/:agentId',
      componentPath: '@reflex/plugin-sandbox-filesystem/web/FilesystemPreviewPage',
    },
  ],
  // The overview card is written by hand so the plugin detail page renders a
  // rich About section; `to` targets the canonical plugin detail page.
  overviewCards: [
    {
      to: '/org/plugins/sandbox-filesystem',
      label: 'Sandbox Filesystem',
      icon: 'FolderTree',
      description: 'Browse the agent devbox filesystem in a Finder-style explorer.',
      details:
        'Opens a file explorer tab on every agent so you can navigate and manage the live devbox filesystem, inspect what the agent has touched, and preview files without dropping into a shell or syncing them locally.',
      features: [
        '"Filesystem" tab on every agent detail page',
        'Finder-style tree navigation of the live devbox',
        'Create, rename, move, and delete files and folders',
        'Upload, download, and edit text files',
        'Inline previews for text, code, and markdown',
        'Inline image previews',
        'Reads straight from the running devbox with no local sync',
      ],
      group: 'plugins',
    },
  ],
  agentTabs: [
    {
      id: 'sandbox-filesystem',
      label: 'Filesystem',
      icon: 'FolderTree',
      componentPath: '@reflex/plugin-sandbox-filesystem/web/FilesystemTab',
    },
  ],
  // Linkify absolute file paths in agent markdown into an inline file-preview
  // popover (replaces the host's old hardcoded `reflex-file:` pipeline). The
  // pattern is shared with `detectFilePaths`; the component reads the current
  // agent id from `MarkdownContent`'s context.
  contentScanners: [
    {
      id: 'sandbox-filesystem:absolute-path',
      target: 'text',
      pattern: ABSOLUTE_PATH_SCANNER_PATTERN,
      componentPath: '@reflex/plugin-sandbox-filesystem/web/components/FilePathScanner',
    },
  ],
  marketingPreviews: [
    {
      id: 'filesystem-panel',
      label: 'Filesystem agent panel',
      description:
        'The "Filesystem" tab that appears on every agent — navigate a sample devbox filesystem with inline code preview for the selected file.',
      surface: 'panel',
      componentPath: '@reflex/plugin-sandbox-filesystem/web/FilesystemTabPreview',
    },
  ],
};
